export const FooterLink2 = [
  {
    title: "Services",
    links: [
      { title: "Website Development", link: "/services/web-development" },
      { title: "App Development", link: "/services/mobile-app-development" },
      { title: "Enterprise Solutions", link: "/services/ecommerce-solutions" },
      { title: "Email Services", link: "/services/email-services" }
    ],
  },
  {
    title: "Support & Resources",
    links: [
      { title: "Portfolio", link: "/portfolio" },
    ],
  },
  {
    title: "Company",
    links: [
        {title: "About Us", link: "/aboutus"},
        {title: "Privacy Policy", link: "/privacypolicy"},
        {title: "Cookie Policy", link: "/cookiepolicy"},
        {title: "Terms & Conditions", link: "/termsandcondition"},
    ]
  },
  {
      title: "Engage Us",
      links: [
          {title: "Contact Support", link: "/contactus"},
      ]
    }
];